export default class PermissionArea {
  id: string;
  name: string;
  shortName: string;
}
